module.exports = __webpack_public_path__ + "static/media/gpbook.24456f6a.gif";


//////////////////
// WEBPACK FOOTER
// ./src/Containers/Home/gpbook.gif
// module id = 642
// module chunks = 0